export const EducationList = [
    {
        college: 'University of Mumbai, MGMCET Kamothe',
        mode: 'Bachelor of Engineering, Computer',
        gpa: '8.94 CGPA',
        timeline: '2024',
    },
    {
        college: 'St. Xavier\'s, Nerul',
        mode: 'Higher Secondary Certificate, Information Technology',
        gpa: '8.4 CGPA',
        timeline: '2020',
    },
    {
        college: 'DAV Public School, Nerul',
        mode: 'Secondary School Certificate',
        gpa: '88.20\%',
        timeline: '2018',
    },
]